import React from "react";
import { Building2 } from "lucide-react";
import HActionButton from "./HActionButton";

const HEmptyState = ({
  icon: CustomIcon = Building2,
  title = "No items found",
  description = "Get started by adding your first item",
  actionLabel,
  onAction,
  className = "",
}) => {
  return (
    <div className={`flex flex-col items-center justify-center py-12 px-6 text-center ${className}`}>
      {/* Large Icon */}
      <div className="mb-6">
        <CustomIcon className="w-16 h-16 text-gray-400" />
      </div>

      {/* Title */}
      <h3 className="text-xl font-semibold text-gray-900 mb-2">{title}</h3>

      {/* Description */}
      <p className="text-gray-600 mb-6 max-w-sm">{description}</p>

      {/* Optional Action Button */}
      {actionLabel && onAction && (
        <HActionButton
          label={actionLabel}
          onClick={onAction}
          variant="outline"
          // size="mediu"
          className="px-6 py-3"
        />
      )}
    </div>
  );
};

export default HEmptyState;
